import { render, staticRenderFns } from "./ViewerDesign.vue?vue&type=template&id=55893fc9&scoped=true"
import script from "./ViewerDesign.vue?vue&type=script&lang=js"
export * from "./ViewerDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerDesign.vue?vue&type=style&index=0&id=55893fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55893fc9",
  null
  
)

export default component.exports